var map = {
	"./aarch64/aarch64-line.svg": 70500,
	"./aarch64/aarch64-original.svg": 45156,
	"./aarch64/aarch64-plain.svg": 98316,
	"./adonisjs/adonisjs-original-wordmark.svg": 90038,
	"./adonisjs/adonisjs-original.svg": 4989,
	"./aftereffects/aftereffects-original.svg": 24150,
	"./aftereffects/aftereffects-plain.svg": 98108,
	"./aftereffects/aftereffects.eps": 29343,
	"./akka/akka-original-wordmark.svg": 39533,
	"./akka/akka-original.svg": 34615,
	"./akka/akka-plain-wordmark.svg": 11544,
	"./akka/akka-plain.svg": 57196,
	"./algolia/algolia-original-wordmark.svg": 43952,
	"./algolia/algolia-original.svg": 82246,
	"./alpinejs/alpinejs-original-wordmark.svg": 25212,
	"./alpinejs/alpinejs-original.svg": 16506,
	"./alpinejs/alpinejs.eps": 82183,
	"./amazonwebservices/amazonwebservices-line-wordmark.svg": 12821,
	"./amazonwebservices/amazonwebservices-original-wordmark.svg": 7617,
	"./amazonwebservices/amazonwebservices-plain-wordmark.svg": 76703,
	"./anaconda/anaconda-original-wordmark.svg": 74111,
	"./anaconda/anaconda-original.svg": 30729,
	"./android/android-original-wordmark.svg": 42199,
	"./android/android-original.svg": 99830,
	"./android/android-plain-wordmark.svg": 12104,
	"./android/android-plain.svg": 54601,
	"./android/android.eps": 51342,
	"./androidstudio/androidstudio-original-wordmark.svg": 10265,
	"./androidstudio/androidstudio-original.svg": 94381,
	"./androidstudio/androidstudio-plain-wordmark.svg": 6035,
	"./androidstudio/androidstudio-plain.svg": 2198,
	"./androidstudio/androidstudio.eps": 89504,
	"./angular/angular-original-wordmark.svg": 64085,
	"./angular/angular-original.svg": 11716,
	"./angular/angular-plain-wordmark.svg": 9075,
	"./angular/angular-plain.svg": 2780,
	"./angularjs/angularjs-original-wordmark.svg": 11097,
	"./angularjs/angularjs-original.svg": 36420,
	"./angularjs/angularjs-plain-wordmark.svg": 61430,
	"./angularjs/angularjs-plain.svg": 94370,
	"./angularjs/angularjs.eps": 48355,
	"./angularmaterial/angularmaterial-original.svg": 61523,
	"./angularmaterial/angularmaterial-plain.svg": 17616,
	"./ansible/ansible-original-wordmark.svg": 11735,
	"./ansible/ansible-original.svg": 78593,
	"./ansible/ansible-plain-wordmark.svg": 54572,
	"./ansible/ansible-plain.svg": 93717,
	"./ansible/ansible.eps": 51273,
	"./antdesign/antdesign-original-wordmark.svg": 47041,
	"./antdesign/antdesign-original.svg": 28093,
	"./antdesign/antdesign-plain-wordmark.svg": 96947,
	"./antdesign/antdesign-plain.svg": 7848,
	"./apache/apache-line-wordmark.svg": 21625,
	"./apache/apache-line.svg": 71660,
	"./apache/apache-original-wordmark.svg": 22741,
	"./apache/apache-original.svg": 11145,
	"./apache/apache-plain-wordmark.svg": 59354,
	"./apache/apache-plain.svg": 34010,
	"./apacheairflow/apacheairflow-original-wordmark.svg": 56670,
	"./apacheairflow/apacheairflow-original.svg": 17728,
	"./apacheairflow/apacheairflow-plain-wordmark.svg": 9026,
	"./apacheairflow/apacheairflow-plain.svg": 72279,
	"./apachekafka/apachekafka-original-wordmark.svg": 97785,
	"./apachekafka/apachekafka-original.svg": 42192,
	"./apachespark/apachespark-original-wordmark.svg": 89770,
	"./apachespark/apachespark-original.svg": 19022,
	"./apachespark/apachespark-plain-wordmark.svg": 74842,
	"./apl/apl-original.svg": 83395,
	"./apl/apl-plain.svg": 33448,
	"./appcelerator/appcelerator-original-wordmark.svg": 17460,
	"./appcelerator/appcelerator-original.svg": 60507,
	"./appcelerator/appcelerator-plain-wordmark.svg": 13390,
	"./appcelerator/appcelerator.eps": 7677,
	"./apple/apple-original.svg": 26690,
	"./apple/apple.eps": 59025,
	"./appwrite/appwrite-original-wordmark.svg": 97802,
	"./appwrite/appwrite-original.svg": 95809,
	"./appwrite/appwrite-plain-wordmark.svg": 24204,
	"./appwrite/appwrite-plain.svg": 8691,
	"./appwrite/appwrite.eps": 20432,
	"./archlinux/archlinux-original-wordmark.svg": 21874,
	"./archlinux/archlinux-original.svg": 96745,
	"./archlinux/archlinux-plain-wordmark.svg": 32534,
	"./archlinux/archlinux-plain.svg": 43182,
	"./arduino/arduino-original-wordmark.svg": 14914,
	"./arduino/arduino-original.svg": 85965,
	"./arduino/arduino-plain-wordmark.svg": 90278,
	"./arduino/arduino-plain.svg": 79375,
	"./argocd/argocd-original-wordmark.svg": 73592,
	"./argocd/argocd-original.svg": 48582,
	"./argocd/argocd-plain-wordmark.svg": 8696,
	"./argocd/argocd-plain.svg": 5683,
	"./astro/astro-original-wordmark.svg": 57532,
	"./astro/astro-original.svg": 48678,
	"./astro/astro-plain-wordmark.svg": 85785,
	"./astro/astro-plain.svg": 15776,
	"./atom/atom-original-wordmark.svg": 13481,
	"./atom/atom-original.svg": 17147,
	"./atom/atom.eps": 47535,
	"./awk/awk-original-wordmark.svg": 56256,
	"./awk/awk-plain-wordmark.svg": 2414,
	"./axios/axios-plain-wordmark.svg": 24530,
	"./axios/axios-plain.svg": 78153,
	"./azure/azure-original-wordmark.svg": 61391,
	"./azure/azure-original.svg": 32847,
	"./azure/azure-plain-wordmark.svg": 23845,
	"./azure/azure-plain.svg": 47394,
	"./azuredevops/azuredevops-original.svg": 66097,
	"./azuredevops/azuredevops-plain.svg": 49565,
	"./azuresqldatabase/azuresqldatabase-original.svg": 91571,
	"./azuresqldatabase/azuresqldatabase-plain.svg": 57724,
	"./babel/babel-original.svg": 68198,
	"./babel/babel-plain.svg": 15705,
	"./babel/babel.eps": 34794,
	"./backbonejs/backbonejs-original-wordmark.svg": 25899,
	"./backbonejs/backbonejs-original.svg": 63717,
	"./backbonejs/backbonejs-plain-wordmark.svg": 84327,
	"./backbonejs/backbonejs-plain.svg": 31165,
	"./backbonejs/backbonejs.eps": 28964,
	"./ballerina/ballerina-line-wordmark.svg": 63329,
	"./ballerina/ballerina-line.svg": 93269,
	"./ballerina/ballerina-original-wordmark.svg": 76831,
	"./ballerina/ballerina-original.svg": 12392,
	"./bamboo/bamboo-original-wordmark.svg": 55285,
	"./bamboo/bamboo-original.svg": 20859,
	"./bash/bash-original.svg": 3519,
	"./bash/bash-plain.svg": 95948,
	"./bash/bash.eps": 45204,
	"./beats/beats-original.svg": 99064,
	"./beats/beats-plain.svg": 73017,
	"./behance/behance-original-wordmark.svg": 46182,
	"./behance/behance-original.svg": 11140,
	"./behance/behance-plain-wordmark.svg": 68716,
	"./behance/behance-plain.svg": 52639,
	"./behance/behance.eps": 733,
	"./bitbucket/bitbucket-original-wordmark.svg": 39161,
	"./bitbucket/bitbucket-original.svg": 96022,
	"./bitbucket/bitbucket.eps": 57629,
	"./blazor/blazor-line.svg": 77097,
	"./blazor/blazor-original.svg": 12892,
	"./blender/blender-original-wordmark.svg": 43130,
	"./blender/blender-original.svg": 67009,
	"./bootstrap/bootstrap-original-wordmark.svg": 6403,
	"./bootstrap/bootstrap-original.svg": 60077,
	"./bootstrap/bootstrap-plain-wordmark.svg": 63148,
	"./bootstrap/bootstrap-plain.svg": 19070,
	"./bower/bower-line-wordmark.svg": 87593,
	"./bower/bower-line.svg": 95560,
	"./bower/bower-original-wordmark.svg": 44727,
	"./bower/bower-original.svg": 49314,
	"./bower/bower-plain-wordmark.svg": 50599,
	"./bower/bower-plain.svg": 45148,
	"./bower/bower.eps": 92816,
	"./browserstack/browserstack-line-wordmark.svg": 68245,
	"./browserstack/browserstack-line.svg": 68537,
	"./browserstack/browserstack-original-wordmark.svg": 29190,
	"./browserstack/browserstack-original.svg": 2203,
	"./browserstack/browserstack-plain-wordmark.svg": 39631,
	"./browserstack/browserstack-plain.svg": 31431,
	"./bulma/bulma-plain.svg": 68089,
	"./bun/bun-line.svg": 4814,
	"./bun/bun-original.svg": 59350,
	"./bun/bun-plain.svg": 45858,
	"./c/c-line.svg": 82850,
	"./c/c-original.svg": 91086,
	"./c/c-plain.svg": 42460,
	"./c/c.eps": 65529,
	"./cairo/cairo-original-wordmark.svg": 53465,
	"./cairo/cairo-original.svg": 17213,
	"./cairo/cairo-plain-wordmark.svg": 7664,
	"./cairo/cairo-plain.svg": 6405,
	"./cakephp/cakephp-original-wordmark.svg": 26779,
	"./cakephp/cakephp-original.svg": 95507,
	"./cakephp/cakephp-plain-wordmark.svg": 75511,
	"./cakephp/cakephp-plain.svg": 65208,
	"./cakephp/cakephp.eps": 74948,
	"./canva/canva-original.svg": 84087,
	"./capacitor/capacitor-original-wordmark.svg": 87334,
	"./capacitor/capacitor-original.svg": 10655,
	"./capacitor/capacitor-plain-wordmark.svg": 41394,
	"./capacitor/capacitor-plain.svg": 21419,
	"./carbon/carbon-original.svg": 13079,
	"./cassandra/cassandra-original-wordmark.svg": 92364,
	"./cassandra/cassandra-original.svg": 34052,
	"./cassandra/cassandra-plain-wordmark.svg": 86403,
	"./cassandra/cassandra-plain.svg": 30222,
	"./centos/centos-original-wordmark.svg": 38243,
	"./centos/centos-original.svg": 41309,
	"./centos/centos-plain-wordmark.svg": 74936,
	"./centos/centos-plain.svg": 4624,
	"./ceylon/ceylon-original-wordmark.svg": 38844,
	"./ceylon/ceylon-original.svg": 92117,
	"./ceylon/ceylon-plain-wordmark.svg": 4785,
	"./ceylon/ceylon-plain.svg": 61805,
	"./ceylon/ceylon.eps": 11467,
	"./chrome/chrome-original-wordmark.svg": 40906,
	"./chrome/chrome-original.svg": 68754,
	"./chrome/chrome-plain-wordmark.svg": 38312,
	"./chrome/chrome-plain.svg": 93199,
	"./chrome/chrome.eps": 35130,
	"./circleci/circleci-plain-wordmark.svg": 77460,
	"./circleci/circleci-plain.svg": 3390,
	"./circleci/circleci.eps": 39329,
	"./clarity/clarity-original-wordmark.svg": 1162,
	"./clarity/clarity-original.svg": 49180,
	"./clarity/clarity-plain-wordmark.svg": 60992,
	"./clarity/clarity-plain.svg": 65757,
	"./clion/clion-original-wordmark.svg": 8618,
	"./clion/clion-original.svg": 10538,
	"./clion/clion-plain-wordmark.svg": 58726,
	"./clion/clion-plain.svg": 72188,
	"./clojure/clojure-line.svg": 26607,
	"./clojure/clojure-original.svg": 71600,
	"./clojure/clojure.eps": 14537,
	"./clojurescript/clojurescript-original.svg": 46380,
	"./clojurescript/clojurescript-plain.svg": 72905,
	"./clojurescript/clojurescript.eps": 91505,
	"./cloudflare/cloudflare-original-wordmark.svg": 94481,
	"./cloudflare/cloudflare-original.svg": 41268,
	"./cloudflare/cloudflare-plain-wordmark.svg": 1854,
	"./cloudflare/cloudflare-plain.svg": 61579,
	"./cloudflare/cloudflare.eps": 8162,
	"./cloudflareworkers/cloudflareworkers-original-wordmark.svg": 98936,
	"./cloudflareworkers/cloudflareworkers-original.svg": 45018,
	"./cloudflareworkers/cloudflareworkers-plain-wordmark.svg": 41935,
	"./cloudflareworkers/cloudflareworkers-plain.svg": 63874,
	"./cloudflareworkers/cloudflareworkers.eps": 96698,
	"./cmake/cmake-original-wordmark.svg": 11520,
	"./cmake/cmake-original.svg": 42577,
	"./cmake/cmake-plain-wordmark.svg": 53088,
	"./cmake/cmake-plain.svg": 28245,
	"./codeac/codeac-original.svg": 61142,
	"./codecov/codecov-plain.svg": 62753,
	"./codecov/codecov.eps": 23683,
	"./codeigniter/codeigniter-plain-wordmark.svg": 143,
	"./codeigniter/codeigniter-plain.svg": 8822,
	"./codeigniter/codeigniter.eps": 99167,
	"./codepen/codepen-line-wordmark.svg": 54301,
	"./codepen/codepen-line.svg": 65455,
	"./codepen/codepen-original-wordmark.svg": 18279,
	"./codepen/codepen-original.svg": 16913,
	"./coffeescript/coffeescript-original-wordmark.svg": 30865,
	"./coffeescript/coffeescript-original.svg": 69870,
	"./coffeescript/coffeescript.eps": 10035,
	"./composer/composer-line-wordmark.svg": 3586,
	"./composer/composer-line.svg": 17543,
	"./composer/composer-original.svg": 73887,
	"./composer/composer.eps": 19316,
	"./confluence/confluence-line-wordmark.svg": 62199,
	"./confluence/confluence-line.svg": 24451,
	"./confluence/confluence-original-wordmark.svg": 59768,
	"./confluence/confluence-original.svg": 35897,
	"./confluence/confluence-plain-wordmark.svg": 96638,
	"./confluence/confluence-plain.svg": 23959,
	"./consul/consul-original-wordmark.svg": 93164,
	"./consul/consul-original.svg": 49549,
	"./consul/consul-plain-wordmark.svg": 2021,
	"./contao/contao-original-wordmark.svg": 60014,
	"./contao/contao-original.svg": 91612,
	"./corejs/corejs-original-wordmark.svg": 55038,
	"./corejs/corejs-original.svg": 70265,
	"./cosmosdb/cosmosdb-original-wordmark.svg": 37070,
	"./cosmosdb/cosmosdb-original.svg": 12632,
	"./cosmosdb/cosmosdb-plain-wordmark.svg": 81714,
	"./cosmosdb/cosmosdb-plain.svg": 74336,
	"./couchbase/couchbase-original-wordmark.svg": 18848,
	"./couchbase/couchbase-original.svg": 52676,
	"./couchbase/couchbase-plain-wordmark.svg": 18280,
	"./couchdb/couchdb-original-wordmark.svg": 99622,
	"./couchdb/couchdb-original.svg": 76931,
	"./couchdb/couchdb-plain-wordmark.svg": 37142,
	"./couchdb/couchdb-plain.svg": 66254,
	"./couchdb/couchdb.eps": 884,
	"./cplusplus/cplusplus-line.svg": 16173,
	"./cplusplus/cplusplus-original.svg": 69328,
	"./cplusplus/cplusplus-plain.svg": 15803,
	"./crystal/crystal-line-wordmark.svg": 94873,
	"./crystal/crystal-line.svg": 88427,
	"./crystal/crystal-original-wordmark.svg": 7166,
	"./crystal/crystal-original.svg": 66344,
	"./csharp/csharp-line.svg": 65051,
	"./csharp/csharp-original.svg": 15943,
	"./csharp/csharp-plain.svg": 59630,
	"./csharp/csharp.eps": 7555,
	"./css3/css3-original-wordmark.svg": 30171,
	"./css3/css3-original.svg": 55847,
	"./css3/css3-plain-wordmark.svg": 59614,
	"./css3/css3-plain.svg": 24237,
	"./css3/css3.eps": 90985,
	"./cucumber/cucumber-plain-wordmark.svg": 48105,
	"./cucumber/cucumber-plain.svg": 43317,
	"./cypressio/cypressio-line-wordmark.svg": 75161,
	"./cypressio/cypressio-line.svg": 22459,
	"./cypressio/cypressio-original-wordmark.svg": 87578,
	"./cypressio/cypressio-original.svg": 72446,
	"./cypressio/cypressio-plain-wordmark.svg": 72631,
	"./cypressio/cypressio-plain.svg": 12053,
	"./d3js/d3js-original.svg": 55427,
	"./d3js/d3js-plain.svg": 21720,
	"./d3js/d3js.eps": 93828,
	"./dart/dart-original-wordmark.svg": 73286,
	"./dart/dart-original.svg": 8705,
	"./dart/dart-plain-wordmark.svg": 7089,
	"./dart/dart-plain.svg": 90486,
	"./datagrip/datagrip-original.svg": 42225,
	"./datagrip/datagrip-plain-wordmark.svg": 59668,
	"./datagrip/datagrip-plain.svg": 75580,
	"./dataspell/dataspell-original-wordmark.svg": 28246,
	"./dataspell/dataspell-original.svg": 95977,
	"./dataspell/dataspell-plain-wordmark.svg": 88025,
	"./dataspell/dataspell-plain.svg": 21652,
	"./dbeaver/dbeaver-original.svg": 89701,
	"./dbeaver/dbeaver-plain.svg": 45506,
	"./debian/debian-original-wordmark.svg": 54151,
	"./debian/debian-original.svg": 29469,
	"./debian/debian-plain-wordmark.svg": 57730,
	"./debian/debian-plain.svg": 4897,
	"./debian/debian.eps": 99481,
	"./denojs/denojs-original-wordmark.svg": 76832,
	"./denojs/denojs-original.svg": 72175,
	"./devicon/devicon-line-wordmark.svg": 2627,
	"./devicon/devicon-line.svg": 93309,
	"./devicon/devicon-original-wordmark.svg": 41830,
	"./devicon/devicon-original.svg": 16266,
	"./devicon/devicon-plain-wordmark.svg": 58808,
	"./devicon/devicon-plain.svg": 19414,
	"./devicon/devicon.eps": 95785,
	"./digitalocean/digitalocean-original-wordmark.svg": 4120,
	"./digitalocean/digitalocean-original.svg": 99119,
	"./discordjs/discordjs-original-wordmark.svg": 90646,
	"./discordjs/discordjs-original.svg": 31359,
	"./discordjs/discordjs-plain-wordmark.svg": 56473,
	"./discordjs/discordjs-plain.svg": 28326,
	"./django/django-plain-wordmark.svg": 67663,
	"./django/django-plain.svg": 41545,
	"./djangorest/djangorest-line-wordmark.svg": 8518,
	"./djangorest/djangorest-line.svg": 22391,
	"./djangorest/djangorest-original-wordmark.svg": 43850,
	"./djangorest/djangorest-original.svg": 16561,
	"./djangorest/djangorest-plain-wordmark.svg": 32177,
	"./djangorest/djangorest-plain.svg": 806,
	"./docker/docker-original-wordmark.svg": 60456,
	"./docker/docker-original.svg": 19933,
	"./docker/docker-plain-wordmark.svg": 8548,
	"./docker/docker-plain.svg": 64615,
	"./docker/docker.eps": 55068,
	"./doctrine/doctrine-line-wordmark.svg": 7993,
	"./doctrine/doctrine-line.svg": 29567,
	"./doctrine/doctrine-original-wordmark.svg": 80270,
	"./doctrine/doctrine-original.svg": 43790,
	"./doctrine/doctrine-plain-wordmark.svg": 64976,
	"./doctrine/doctrine-plain.svg": 68860,
	"./doctrine/doctrine.eps": 63261,
	"./dot-net/dot-net-original-wordmark.svg": 36207,
	"./dot-net/dot-net-original.svg": 31993,
	"./dot-net/dot-net-plain-wordmark.svg": 48236,
	"./dot-net/dot-net-plain.svg": 44461,
	"./dot-net/dot-net.eps": 80051,
	"./dotnetcore/dotnetcore-original.svg": 17312,
	"./dotnetcore/dotnetcore-plain.svg": 55674,
	"./dreamweaver/dreamweaver-line.svg": 94787,
	"./dreamweaver/dreamweaver-original.svg": 86032,
	"./dreamweaver/dreamweaver-plain.svg": 21171,
	"./dropwizard/dropwizard-original.svg": 18587,
	"./dropwizard/dropwizard-plain.svg": 63970,
	"./drupal/drupal-original-wordmark.svg": 52164,
	"./drupal/drupal-original.svg": 7331,
	"./drupal/drupal-plain-wordmark.svg": 24239,
	"./drupal/drupal-plain.svg": 85560,
	"./drupal/drupal.eps": 71977,
	"./dynamodb/dynamodb-original.svg": 39006,
	"./dynamodb/dynamodb-plain.svg": 21066,
	"./eclipse/eclipse-original-wordmark.svg": 10200,
	"./eclipse/eclipse-original.svg": 31733,
	"./eclipse/eclipse-plain-wordmark.svg": 76480,
	"./eclipse/eclipse-plain.svg": 80567,
	"./ecto/ecto-original-wordmark.svg": 76519,
	"./ecto/ecto-original.svg": 9709,
	"./ecto/ecto-plain-wordmark.svg": 77444,
	"./ecto/ecto.eps": 69419,
	"./elasticsearch/elasticsearch-original-wordmark.svg": 11805,
	"./elasticsearch/elasticsearch-original.svg": 64762,
	"./elasticsearch/elasticsearch-plain-wordmark.svg": 80400,
	"./elasticsearch/elasticsearch-plain.svg": 88928,
	"./electron/electron-original-wordmark.svg": 93407,
	"./electron/electron-original.svg": 45055,
	"./electron/electron.eps": 14803,
	"./eleventy/eleventy-original.svg": 47320,
	"./eleventy/eleventy-plain.svg": 83692,
	"./elixir/elixir-original-wordmark.svg": 49996,
	"./elixir/elixir-original.svg": 87699,
	"./elixir/elixir-plain-wordmark.svg": 24481,
	"./elixir/elixir-plain.svg": 4090,
	"./elm/elm-original-wordmark.svg": 14,
	"./elm/elm-original.svg": 12359,
	"./elm/elm-plain-wordmark.svg": 49725,
	"./elm/elm-plain.svg": 41717,
	"./elm/elm.eps": 32091,
	"./emacs/emacs-original.svg": 16802,
	"./embeddedc/embeddedc-original-wordmark.svg": 86770,
	"./embeddedc/embeddedc-original.svg": 1507,
	"./embeddedc/embeddedc-plain-wordmark.svg": 97666,
	"./embeddedc/embeddedc-plain.svg": 83209,
	"./embeddedc/embeddedc.eps": 86203,
	"./ember/ember-original-wordmark.svg": 84340,
	"./ember/ember-original.svg": 49014,
	"./ember/ember-plain.svg": 3057,
	"./ember/ember.eps": 58104,
	"./envoy/envoy-original-wordmark.svg": 98224,
	"./envoy/envoy-original.svg": 29593,
	"./envoy/envoy-plain-wordmark.svg": 18759,
	"./envoy/envoy-plain.svg": 20121,
	"./erlang/erlang-original-wordmark.svg": 77971,
	"./erlang/erlang-original.svg": 95692,
	"./erlang/erlang-plain-wordmark.svg": 10174,
	"./erlang/erlang-plain.svg": 92149,
	"./erlang/erlang.eps": 85012,
	"./eslint/eslint-line-wordmark.svg": 99951,
	"./eslint/eslint-line.svg": 16136,
	"./eslint/eslint-original-wordmark.svg": 86196,
	"./eslint/eslint-original.svg": 90400,
	"./eslint/eslint-plain-wordmark.svg": 88801,
	"./eslint/eslint-plain.svg": 96004,
	"./express/express-original-wordmark.svg": 49722,
	"./express/express-original.svg": 66112,
	"./express/express.eps": 50807,
	"./facebook/facebook-original.svg": 63923,
	"./facebook/facebook-plain.svg": 74567,
	"./facebook/facebook.eps": 82062,
	"./fastapi/fastapi-original-wordmark.svg": 48799,
	"./fastapi/fastapi-original.svg": 84692,
	"./fastapi/fastapi-plain-wordmark.svg": 69057,
	"./fastapi/fastapi-plain.svg": 58195,
	"./fastify/fastify-original-wordmark.svg": 20118,
	"./fastify/fastify-original.svg": 44057,
	"./fastify/fastify-plain-wordmark.svg": 82091,
	"./fastify/fastify-plain.svg": 26117,
	"./fastify/fastify.eps": 71864,
	"./faunadb/faunadb-line-wordmark.svg": 18687,
	"./faunadb/faunadb-line.svg": 79400,
	"./faunadb/faunadb-original-wordmark.svg": 48597,
	"./faunadb/faunadb-original.svg": 85358,
	"./feathersjs/feathersjs-original.svg": 68845,
	"./fedora/fedora-original.svg": 78292,
	"./fedora/fedora-plain.svg": 2419,
	"./figma/figma-original.svg": 98069,
	"./figma/figma-plain.svg": 76383,
	"./filezilla/filezilla-line-wordmark.svg": 48533,
	"./filezilla/filezilla-line.svg": 31782,
	"./filezilla/filezilla-original-wordmark.svg": 25193,
	"./filezilla/filezilla-original.svg": 59484,
	"./filezilla/filezilla-plain-wordmark.svg": 64909,
	"./filezilla/filezilla-plain.svg": 26459,
	"./firebase/firebase-line-wordmark.svg": 95509,
	"./firebase/firebase-line.svg": 60523,
	"./firebase/firebase-original-wordmark.svg": 14044,
	"./firebase/firebase-original.svg": 73301,
	"./firebase/firebase-plain-wordmark.svg": 37577,
	"./firebase/firebase-plain.svg": 27048,
	"./firefox/firefox-original-wordmark.svg": 93268,
	"./firefox/firefox-original.svg": 72513,
	"./firefox/firefox-plain-wordmark.svg": 68583,
	"./firefox/firefox-plain.svg": 854,
	"./firefox/firefox.eps": 10074,
	"./flask/flask-original-wordmark.svg": 13885,
	"./flask/flask-original.svg": 70595,
	"./flutter/flutter-original.svg": 68562,
	"./flutter/flutter-plain.svg": 91737,
	"./flutter/flutter.eps": 7670,
	"./fortran/fortran-original.svg": 80100,
	"./foundation/foundation-original-wordmark.svg": 98817,
	"./foundation/foundation-original.svg": 12059,
	"./foundation/foundation-plain-wordmark.svg": 45602,
	"./foundation/foundation-plain.svg": 67701,
	"./foundation/foundation.eps": 86834,
	"./framermotion/framermotion-original-wordmark.svg": 28855,
	"./framermotion/framermotion-original.svg": 42028,
	"./framework7/framework7-original-wordmark.svg": 36583,
	"./framework7/framework7-original.svg": 65486,
	"./fsharp/fsharp-original.svg": 76438,
	"./fsharp/fsharp-plain.svg": 81184,
	"./gatling/gatling-line-wordmark.svg": 4430,
	"./gatling/gatling-line.svg": 30279,
	"./gatling/gatling-original-wordmark.svg": 81068,
	"./gatling/gatling-original.svg": 98731,
	"./gatling/gatling-plain-wordmark.svg": 25753,
	"./gatsby/gatsby-original-wordmark.svg": 66813,
	"./gatsby/gatsby-original.svg": 78033,
	"./gatsby/gatsby-plain-wordmark.svg": 95217,
	"./gatsby/gatsby.eps": 55271,
	"./gazebo/gazebo-original-wordmark.svg": 66435,
	"./gazebo/gazebo-original.svg": 6428,
	"./gazebo/gazebo-plain-wordmark.svg": 64769,
	"./gazebo/gazebo-plain.svg": 26450,
	"./gcc/gcc-line.svg": 98551,
	"./gcc/gcc-original.svg": 10877,
	"./gcc/gcc-plain.svg": 25838,
	"./gentoo/gentoo-line-wordmark.svg": 61733,
	"./gentoo/gentoo-line.svg": 86817,
	"./gentoo/gentoo-original-wordmark.svg": 23325,
	"./gentoo/gentoo-original.svg": 2685,
	"./gentoo/gentoo-plain-wordmark.svg": 43113,
	"./gentoo/gentoo-plain.svg": 31062,
	"./ghost/ghost-original-wordmark.svg": 35479,
	"./ghost/ghost-original.svg": 12271,
	"./gimp/gimp-line-wordmark.svg": 70636,
	"./gimp/gimp-line.svg": 56891,
	"./gimp/gimp-original-wordmark.svg": 36026,
	"./gimp/gimp-original.svg": 76428,
	"./gimp/gimp-plain-wordmark.svg": 26878,
	"./gimp/gimp-plain.svg": 99322,
	"./git/git-original-wordmark.svg": 94913,
	"./git/git-original.svg": 23716,
	"./git/git-plain-wordmark.svg": 86181,
	"./git/git-plain.svg": 38099,
	"./git/git.eps": 33083,
	"./gitbook/gitbook-line-wordmark.svg": 85516,
	"./gitbook/gitbook-line.svg": 9054,
	"./gitbook/gitbook-original-wordmark.svg": 39007,
	"./gitbook/gitbook-original.svg": 13529,
	"./github/github-original-wordmark.svg": 81260,
	"./github/github-original.svg": 23094,
	"./github/github.eps": 78718,
	"./githubactions/githubactions-original.svg": 33713,
	"./githubactions/githubactions-plain.svg": 76363,
	"./githubcodespaces/githubcodespaces-original.svg": 76961,
	"./githubcodespaces/githubcodespaces-plain.svg": 37291,
	"./gitlab/gitlab-original-wordmark.svg": 67149,
	"./gitlab/gitlab-original.svg": 73235,
	"./gitlab/gitlab-plain-wordmark.svg": 56137,
	"./gitlab/gitlab-plain.svg": 15835,
	"./gitlab/gitlab.eps": 59110,
	"./gitpod/gitpod-original-wordmark.svg": 24828,
	"./gitpod/gitpod-original.svg": 89499,
	"./gitpod/gitpod-plain-wordmark.svg": 67744,
	"./gitpod/gitpod-plain.svg": 93428,
	"./gitter/gitter-plain-wordmark.svg": 86372,
	"./gitter/gitter-plain.svg": 88372,
	"./go/go-line.svg": 83118,
	"./go/go-original-wordmark.svg": 27823,
	"./go/go-original.svg": 65507,
	"./go/go-plain.svg": 79699,
	"./go/go.eps": 42110,
	"./godot/godot-original-wordmark.svg": 67470,
	"./godot/godot-original.svg": 95125,
	"./godot/godot-plain-wordmark.svg": 26359,
	"./godot/godot-plain.svg": 63302,
	"./goland/goland-original.svg": 68551,
	"./goland/goland-plain-wordmark.svg": 96130,
	"./goland/goland-plain.svg": 32481,
	"./google/google-original-wordmark.svg": 50525,
	"./google/google-original.svg": 96269,
	"./google/google-plain-wordmark.svg": 62295,
	"./google/google-plain.svg": 29041,
	"./google/google.eps": 55159,
	"./googlecloud/googlecloud-original-wordmark.svg": 21529,
	"./googlecloud/googlecloud-original.svg": 69006,
	"./googlecloud/googlecloud-plain-wordmark.svg": 30327,
	"./googlecloud/googlecloud-plain.svg": 13657,
	"./gradle/gradle-original-wordmark.svg": 89715,
	"./gradle/gradle-original.svg": 28898,
	"./grafana/grafana-line-wordmark.svg": 45527,
	"./grafana/grafana-line.svg": 31023,
	"./grafana/grafana-original-wordmark.svg": 29496,
	"./grafana/grafana-original.svg": 87406,
	"./grafana/grafana-plain-wordmark.svg": 37028,
	"./grafana/grafana-plain.svg": 83761,
	"./grails/grails-original.svg": 65629,
	"./grails/grails-plain.svg": 53235,
	"./graphql/graphql-plain-wordmark.svg": 31698,
	"./graphql/graphql-plain.svg": 42332,
	"./groovy/groovy-original.svg": 49081,
	"./groovy/groovy-plain.svg": 87497,
	"./grpc/grpc-original.svg": 2490,
	"./grpc/grpc-plain.svg": 28302,
	"./grunt/grunt-line-wordmark.svg": 53671,
	"./grunt/grunt-line.svg": 74535,
	"./grunt/grunt-original-wordmark.svg": 53891,
	"./grunt/grunt-original.svg": 63726,
	"./grunt/grunt-plain-wordmark.svg": 88596,
	"./grunt/grunt-plain.svg": 83941,
	"./grunt/grunt.eps": 29746,
	"./gulp/gulp-plain.svg": 14524,
	"./gulp/gulp.eps": 69109,
	"./hadoop/hadoop-original-wordmark.svg": 62398,
	"./hadoop/hadoop-original.svg": 50058,
	"./hadoop/hadoop-plain-wordmark.svg": 48381,
	"./hadoop/hadoop-plain.svg": 58957,
	"./handlebars/handlebars-line-wordmark.svg": 87900,
	"./handlebars/handlebars-line.svg": 37314,
	"./handlebars/handlebars-original-wordmark.svg": 21458,
	"./handlebars/handlebars-original.svg": 93095,
	"./hardhat/hardhat-original-wordmark.svg": 83817,
	"./hardhat/hardhat-original.svg": 83819,
	"./hardhat/hardhat-plain-wordmark.svg": 51283,
	"./hardhat/hardhat-plain.svg": 93991,
	"./harvester/harvester-original-wordmark.svg": 43553,
	"./harvester/harvester-original.svg": 71153,
	"./harvester/harvester-plain-wordmark.svg": 14987,
	"./haskell/haskell-original-wordmark.svg": 46519,
	"./haskell/haskell-original.svg": 33694,
	"./haskell/haskell-plain-wordmark.svg": 66996,
	"./haskell/haskell-plain.svg": 21784,
	"./haskell/haskell.eps": 76261,
	"./haxe/haxe-original.svg": 76771,
	"./haxe/haxe-plain.svg": 332,
	"./haxe/haxe.eps": 46845,
	"./helm/helm-line.svg": 17809,
	"./helm/helm-original.svg": 28747,
	"./heroku/heroku-original-wordmark.svg": 50335,
	"./heroku/heroku-original.svg": 81135,
	"./heroku/heroku-plain-wordmark.svg": 23767,
	"./heroku/heroku-plain.svg": 24274,
	"./heroku/heroku.eps": 93712,
	"./hibernate/hibernate-original-wordmark.svg": 11566,
	"./hibernate/hibernate-original.svg": 24008,
	"./hibernate/hibernate-plain-wordmark.svg": 67891,
	"./hibernate/hibernate-plain.svg": 36737,
	"./homebrew/homebrew-line-wordmark.svg": 88316,
	"./homebrew/homebrew-line.svg": 27290,
	"./homebrew/homebrew-original-wordmark.svg": 43016,
	"./homebrew/homebrew-original.svg": 85354,
	"./homebrew/homebrew-plain-wordmark.svg": 2661,
	"./homebrew/homebrew-plain.svg": 84445,
	"./html5/html5-original-wordmark.svg": 8898,
	"./html5/html5-original.svg": 63029,
	"./html5/html5-plain-wordmark.svg": 91665,
	"./html5/html5-plain.svg": 18189,
	"./html5/html5.eps": 44769,
	"./hugo/hugo-original-wordmark.svg": 97290,
	"./hugo/hugo-original.svg": 69091,
	"./hugo/hugo-plain-wordmark.svg": 93220,
	"./hugo/hugo-plain.svg": 24105,
	"./hugo/hugo.eps": 22432,
	"./ie10/ie10-original.svg": 35616,
	"./ie10/ie10.eps": 18708,
	"./ifttt/ifttt-original.svg": 199,
	"./ifttt/ifttt.eps": 76744,
	"./illustrator/illustrator-line.svg": 88647,
	"./illustrator/illustrator-plain.svg": 782,
	"./illustrator/illustrator.eps": 71626,
	"./influxdb/influxdb-original-wordmark.svg": 73664,
	"./influxdb/influxdb-original.svg": 55211,
	"./inkscape/inkscape-original-wordmark.svg": 13041,
	"./inkscape/inkscape-original.svg": 37274,
	"./inkscape/inkscape-plain-wordmark.svg": 31176,
	"./inkscape/inkscape-plain.svg": 43042,
	"./inkscape/inkscape.eps": 34563,
	"./insomnia/insomnia-original-wordmark.svg": 98537,
	"./insomnia/insomnia-original.svg": 82628,
	"./insomnia/insomnia-plain-wordmark.svg": 90767,
	"./insomnia/insomnia-plain.svg": 52602,
	"./intellij/intellij-original.svg": 64576,
	"./intellij/intellij-plain-wordmark.svg": 74980,
	"./intellij/intellij-plain.svg": 86686,
	"./ionic/ionic-original-wordmark.svg": 22408,
	"./ionic/ionic-original.svg": 32768,
	"./ionic/ionic.eps": 78352,
	"./jaegertracing/jaegertracing-original-wordmark.svg": 47515,
	"./jaegertracing/jaegertracing-original.svg": 45298,
	"./jaegertracing/jaegertracing-plain-wordmark.svg": 39306,
	"./jaegertracing/jaegertracing-plain.svg": 41261,
	"./jamstack/jamstack-original-wordmark.svg": 10716,
	"./jamstack/jamstack-original.svg": 25568,
	"./jamstack/jamstack-plain-wordmark.svg": 84448,
	"./jasmine/jasmine-original-wordmark.svg": 88595,
	"./jasmine/jasmine-original.svg": 15770,
	"./java/java-original-wordmark.svg": 37896,
	"./java/java-original.svg": 47843,
	"./java/java-plain-wordmark.svg": 71111,
	"./java/java-plain.svg": 82038,
	"./java/java.eps": 74963,
	"./javascript/javascript-original.svg": 35460,
	"./javascript/javascript-plain.svg": 82108,
	"./javascript/javascript.eps": 2195,
	"./jeet/jeet-original-wordmark.svg": 35558,
	"./jeet/jeet-original.svg": 67033,
	"./jeet/jeet-plain-wordmark.svg": 30383,
	"./jeet/jeet-plain.svg": 65695,
	"./jeet/jeet.eps": 98155,
	"./jekyll/jekyll-original-wordmark.svg": 83704,
	"./jekyll/jekyll-original.svg": 19303,
	"./jekyll/jekyll-plain-wordmark.svg": 58002,
	"./jekyll/jekyll-plain.svg": 65190,
	"./jenkins/jenkins-line.svg": 47338,
	"./jenkins/jenkins-original.svg": 4358,
	"./jenkins/jenkins-plain.svg": 30467,
	"./jest/jest-plain.svg": 10346,
	"./jest/jest.eps": 85322,
	"./jetbrains/jetbrains-original.svg": 9142,
	"./jetbrains/jetbrains-plain.svg": 17200,
	"./jetpackcompose/jetpackcompose-line-wordmark.svg": 98082,
	"./jetpackcompose/jetpackcompose-line.svg": 15335,
	"./jetpackcompose/jetpackcompose-original-wordmark.svg": 40331,
	"./jetpackcompose/jetpackcompose-original.svg": 6156,
	"./jetpackcompose/jetpackcompose-plain-wordmark.svg": 14840,
	"./jetpackcompose/jetpackcompose-plain.svg": 75737,
	"./jira/jira-original-wordmark.svg": 51333,
	"./jira/jira-original.svg": 95187,
	"./jira/jira-plain-wordmark.svg": 74951,
	"./jira/jira-plain.svg": 86914,
	"./jiraalign/jiraalign-original-wordmark.svg": 11029,
	"./jiraalign/jiraalign-original.svg": 12421,
	"./jiraalign/jiraalign-plain-wordmark.svg": 38073,
	"./jiraalign/jiraalign-plain.svg": 24532,
	"./jquery/jquery-original-wordmark.svg": 50476,
	"./jquery/jquery-original.svg": 9866,
	"./jquery/jquery-plain-wordmark.svg": 60554,
	"./jquery/jquery-plain.svg": 47589,
	"./jquery/jquery.eps": 38787,
	"./json/json-original.svg": 41837,
	"./json/json-plain.svg": 88308,
	"./json/json.eps": 9833,
	"./jule/jule-original-wordmark.svg": 1187,
	"./jule/jule-original.svg": 25786,
	"./julia/julia-original-wordmark.svg": 77941,
	"./julia/julia-original.svg": 50576,
	"./julia/julia-plain-wordmark.svg": 58696,
	"./julia/julia-plain.svg": 43247,
	"./junit/junit-line-wordmark.svg": 20794,
	"./junit/junit-line.svg": 86004,
	"./junit/junit-original-wordmark.svg": 89564,
	"./junit/junit-original.svg": 64091,
	"./junit/junit-plain-wordmark.svg": 44846,
	"./junit/junit-plain.svg": 70807,
	"./jupyter/jupyter-original-wordmark.svg": 77984,
	"./jupyter/jupyter-original.svg": 40333,
	"./jupyter/jupyter-plain-wordmark.svg": 48011,
	"./jupyter/jupyter-plain.svg": 11519,
	"./k3os/k3os-line-wordmark.svg": 710,
	"./k3os/k3os-line.svg": 660,
	"./k3os/k3os-original-wordmark.svg": 64276,
	"./k3os/k3os-original.svg": 49911,
	"./k3os/k3os-plain-wordmark.svg": 63282,
	"./k3s/k3s-original-wordmark.svg": 49526,
	"./k3s/k3s-original.svg": 87567,
	"./k3s/k3s-plain-wordmark.svg": 75811,
	"./k6/k6-original.svg": 16644,
	"./kaggle/kaggle-original-wordmark.svg": 31138,
	"./kaggle/kaggle-original.svg": 55334,
	"./karatelabs/karatelabs-original-wordmark.svg": 37715,
	"./karatelabs/karatelabs-original.svg": 99591,
	"./karatelabs/karatelabs-plain-wordmark.svg": 80620,
	"./karatelabs/karatelabs-plain.svg": 8804,
	"./karma/karma-original.svg": 68188,
	"./karma/karma-plain.svg": 64510,
	"./karma/karma.eps": 21431,
	"./kdeneon/kdeneon-original.svg": 35214,
	"./kdeneon/kdeneon-plain.svg": 67608,
	"./keras/keras-line-wordmark.svg": 16387,
	"./keras/keras-line.svg": 53112,
	"./keras/keras-original-wordmark.svg": 99769,
	"./keras/keras-original.svg": 90621,
	"./keras/keras-plain-wordmark.svg": 35060,
	"./keras/keras-plain.svg": 87559,
	"./kibana/kibana-original-wordmark.svg": 64813,
	"./kibana/kibana-original.svg": 79909,
	"./kibana/kibana-plain-wordmark.svg": 9779,
	"./kibana/kibana-plain.svg": 98497,
	"./knexjs/knexjs-original-wordmark.svg": 49346,
	"./knexjs/knexjs-original.svg": 90757,
	"./knexjs/knexjs-plain-wordmark.svg": 88652,
	"./knockout/knockout-plain-wordmark.svg": 75761,
	"./knockout/knockout.eps": 39919,
	"./kotlin/kotlin-original-wordmark.svg": 75527,
	"./kotlin/kotlin-original.svg": 79147,
	"./kotlin/kotlin-plain-wordmark.svg": 41,
	"./kotlin/kotlin-plain.svg": 89141,
	"./krakenjs/krakenjs-original-wordmark.svg": 71460,
	"./krakenjs/krakenjs-original.svg": 61023,
	"./krakenjs/krakenjs-plain-wordmark.svg": 35009,
	"./krakenjs/krakenjs-plain.svg": 10122,
	"./krakenjs/krakenjs.eps": 27510,
	"./ktor/ktor-original-wordmark.svg": 27645,
	"./ktor/ktor-original.svg": 29000,
	"./ktor/ktor-plain-wordmark.svg": 92043,
	"./ktor/ktor-plain.svg": 15469,
	"./kubernetes/kubernetes-line-wordmark.svg": 13912,
	"./kubernetes/kubernetes-line.svg": 4502,
	"./kubernetes/kubernetes-original-wordmark.svg": 41878,
	"./kubernetes/kubernetes-original.svg": 24633,
	"./kubernetes/kubernetes-plain-wordmark.svg": 55517,
	"./kubernetes/kubernetes-plain.svg": 2314,
	"./labview/labview-original-wordmark.svg": 66580,
	"./labview/labview-original.svg": 9644,
	"./labview/labview-plain-wordmark.svg": 16307,
	"./labview/labview-plain.svg": 62096,
	"./labview/labview.eps": 24096,
	"./laravel/laravel-line-wordmark.svg": 92785,
	"./laravel/laravel-line.svg": 82595,
	"./laravel/laravel-original-wordmark.svg": 95473,
	"./laravel/laravel-original.svg": 96244,
	"./latex/latex-original.svg": 20366,
	"./latex/latex.eps": 56097,
	"./less/less-plain-wordmark.svg": 80410,
	"./less/less.eps": 39703,
	"./linkedin/linkedin-original-wordmark.svg": 96011,
	"./linkedin/linkedin-original.svg": 41614,
	"./linkedin/linkedin-plain-wordmark.svg": 71186,
	"./linkedin/linkedin-plain.svg": 34217,
	"./linkedin/linkedin.eps": 79276,
	"./linux/linux-original.svg": 12308,
	"./linux/linux-plain.svg": 28296,
	"./linux/linux.eps": 45509,
	"./liquibase/liquibase-original-wordmark.svg": 34213,
	"./liquibase/liquibase-original.svg": 28401,
	"./livewire/livewire-original-wordmark.svg": 31537,
	"./livewire/livewire-original.svg": 34066,
	"./livewire/livewire-plain-wordmark.svg": 1730,
	"./livewire/livewire-plain.svg": 70794,
	"./llvm/llvm-original.svg": 43183,
	"./llvm/llvm-plain.svg": 77797,
	"./lodash/lodash-original.svg": 5576,
	"./lodash/lodash-plain.svg": 12597,
	"./logstash/logstash-original-wordmark.svg": 40833,
	"./logstash/logstash-original.svg": 38854,
	"./logstash/logstash-plain-wordmark.svg": 61765,
	"./logstash/logstash-plain.svg": 85352,
	"./lua/lua-line.svg": 66834,
	"./lua/lua-original.svg": 80739,
	"./lua/lua-plain.svg": 57372,
	"./lumen/lumen-original.svg": 91185,
	"./magento/magento-line-wordmark.svg": 4488,
	"./magento/magento-line.svg": 83974,
	"./magento/magento-original-wordmark.svg": 19857,
	"./magento/magento-original.svg": 76236,
	"./magento/magento-plain-wordmark.svg": 75662,
	"./mariadb/mariadb-original-wordmark.svg": 48221,
	"./mariadb/mariadb-original.svg": 6693,
	"./markdown/markdown-original.svg": 13427,
	"./materializecss/materializecss-original.svg": 50738,
	"./materializecss/materializecss-plain.svg": 61364,
	"./materialui/materialui-original.svg": 13889,
	"./materialui/materialui-plain.svg": 3097,
	"./materialui/materialui.eps": 89573,
	"./matlab/matlab-line.svg": 57854,
	"./matlab/matlab-original.svg": 75159,
	"./matlab/matlab-plain.svg": 83515,
	"./matplotlib/matplotlib-original-wordmark.svg": 66640,
	"./matplotlib/matplotlib-original.svg": 99681,
	"./matplotlib/matplotlib-plain-wordmark.svg": 45235,
	"./matplotlib/matplotlib-plain.svg": 3245,
	"./matplotlib/matplotlib.eps": 49674,
	"./maven/maven-original-wordmark.svg": 97139,
	"./maven/maven-original.svg": 18356,
	"./maven/maven-plain-wordmark.svg": 57987,
	"./maven/maven-plain.svg": 31236,
	"./maya/maya-original-wordmark.svg": 640,
	"./maya/maya-original.svg": 14257,
	"./maya/maya-plain-wordmark.svg": 13924,
	"./maya/maya-plain.svg": 63612,
	"./maya/maya.eps": 25800,
	"./meteor/meteor-original-wordmark.svg": 22529,
	"./meteor/meteor-original.svg": 7403,
	"./meteor/meteor-plain-wordmark.svg": 4584,
	"./meteor/meteor-plain.svg": 95840,
	"./meteor/meteor.eps": 11372,
	"./microsoftsqlserver/microsoftsqlserver-line-wordmark.svg": 77561,
	"./microsoftsqlserver/microsoftsqlserver-line.svg": 63619,
	"./microsoftsqlserver/microsoftsqlserver-original-wordmark.svg": 18429,
	"./microsoftsqlserver/microsoftsqlserver-original.svg": 90639,
	"./microsoftsqlserver/microsoftsqlserver-plain-wordmark.svg": 41067,
	"./microsoftsqlserver/microsoftsqlserver-plain.svg": 60161,
	"./minitab/minitab-original.svg": 53713,
	"./minitab/minitab-plain.svg": 12617,
	"./minitab/minitab.eps": 47839,
	"./mithril/mithril-line.svg": 16261,
	"./mithril/mithril-original.svg": 67021,
	"./mobx/mobx-original.svg": 25327,
	"./mobx/mobx-plain.svg": 68984,
	"./mocha/mocha-original.svg": 43794,
	"./mocha/mocha-plain.svg": 18795,
	"./mocha/mocha.eps": 19998,
	"./modx/modx-original-wordmark.svg": 98600,
	"./modx/modx-original.svg": 68964,
	"./modx/modx-plain-wordmark.svg": 17177,
	"./modx/modx-plain.svg": 16996,
	"./modx/modx.eps": 42101,
	"./moleculer/moleculer-original-wordmark.svg": 71939,
	"./moleculer/moleculer-original.svg": 24218,
	"./mongodb/mongodb-original-wordmark.svg": 23571,
	"./mongodb/mongodb-original.svg": 49797,
	"./mongodb/mongodb-plain-wordmark.svg": 8721,
	"./mongodb/mongodb-plain.svg": 33604,
	"./mongodb/mongodb.eps": 63487,
	"./mongoose/mongoose-original-wordmark.svg": 30572,
	"./mongoose/mongoose-original.svg": 39442,
	"./moodle/moodle-original-wordmark.svg": 50420,
	"./moodle/moodle-original.svg": 76542,
	"./moodle/moodle-plain-wordmark.svg": 82170,
	"./moodle/moodle-plain.svg": 50462,
	"./moodle/moodle.eps": 38487,
	"./msdos/msdos-line.svg": 64691,
	"./msdos/msdos-original.svg": 87875,
	"./msdos/msdos-plain.svg": 30130,
	"./mysql/mysql-original-wordmark.svg": 14576,
	"./mysql/mysql-original.svg": 79247,
	"./mysql/mysql-plain-wordmark.svg": 13693,
	"./mysql/mysql.eps": 58526,
	"./nano/nano-original-wordmark.svg": 24943,
	"./nano/nano-original.svg": 90138,
	"./nano/nano-plain-wordmark.svg": 59308,
	"./nano/nano-plain.svg": 23468,
	"./neo4j/neo4j-original-wordmark.svg": 30050,
	"./neo4j/neo4j-original.svg": 89105,
	"./neo4j/neo4j-plain-wordmark.svg": 17970,
	"./neo4j/neo4j-plain.svg": 2942,
	"./neovim/neovim-line-wordmark.svg": 8813,
	"./neovim/neovim-line.svg": 35576,
	"./neovim/neovim-original-wordmark.svg": 48618,
	"./neovim/neovim-original.svg": 10400,
	"./neovim/neovim-plain-wordmark.svg": 78454,
	"./neovim/neovim-plain.svg": 91600,
	"./nestjs/nestjs-line-wordmark.svg": 87720,
	"./nestjs/nestjs-line.svg": 68142,
	"./nestjs/nestjs-original-wordmark.svg": 27169,
	"./nestjs/nestjs-original.svg": 58438,
	"./netlify/netlify-original-wordmark.svg": 9587,
	"./netlify/netlify-original.svg": 62688,
	"./netlify/netlify-plain-wordmark.svg": 34903,
	"./netlify/netlify-plain.svg": 71260,
	"./networkx/networkx-line-wordmark.svg": 24746,
	"./networkx/networkx-line.svg": 85470,
	"./networkx/networkx-original-wordmark.svg": 4977,
	"./networkx/networkx-original.svg": 47905,
	"./networkx/networkx-plain-wordmark.svg": 76096,
	"./networkx/networkx-plain.svg": 49714,
	"./nextjs/nextjs-line-wordmark.svg": 61890,
	"./nextjs/nextjs-line.svg": 43910,
	"./nextjs/nextjs-original-wordmark.svg": 56481,
	"./nextjs/nextjs-original.svg": 35865,
	"./nextjs/nextjs-plain.svg": 35345,
	"./nginx/nginx-original.svg": 66332,
	"./nginx/nginx.eps": 95383,
	"./ngrx/ngrx-original.svg": 88409,
	"./ngrx/ngrx-plain.svg": 4298,
	"./nhibernate/nhibernate-line-wordmark.svg": 86801,
	"./nhibernate/nhibernate-line.svg": 75227,
	"./nhibernate/nhibernate-original-wordmark.svg": 3260,
	"./nhibernate/nhibernate-original.svg": 58981,
	"./nhibernate/nhibernate-plain-wordmark.svg": 89911,
	"./nhibernate/nhibernate-plain.svg": 32235,
	"./nim/nim-line-wordmark.svg": 75540,
	"./nim/nim-line.svg": 98074,
	"./nim/nim-original-wordmark.svg": 97599,
	"./nim/nim-original.svg": 43451,
	"./nim/nim-plain-wordmark.svg": 50840,
	"./nim/nim-plain.svg": 7272,
	"./nimble/nimble-original.svg": 82175,
	"./nimble/nimble-plain.svg": 39419,
	"./nixos/nixos-original-wordmark.svg": 16806,
	"./nixos/nixos-original.svg": 42773,
	"./nixos/nixos-plain-wordmark.svg": 78679,
	"./nixos/nixos-plain.svg": 16486,
	"./nodejs/nodejs-line-wordmark.svg": 13753,
	"./nodejs/nodejs-line.svg": 51624,
	"./nodejs/nodejs-original-wordmark.svg": 90427,
	"./nodejs/nodejs-original.svg": 81599,
	"./nodejs/nodejs-plain-wordmark.svg": 33175,
	"./nodejs/nodejs-plain.svg": 25635,
	"./nodejs/nodejs.eps": 78852,
	"./nodemon/nodemon-line.svg": 44621,
	"./nodemon/nodemon-original.svg": 75073,
	"./nodemon/nodemon-plain.svg": 98902,
	"./nodewebkit/nodewebkit-line-wordmark.svg": 22690,
	"./nodewebkit/nodewebkit-line.svg": 5024,
	"./nodewebkit/nodewebkit-original-wordmark.svg": 92949,
	"./nodewebkit/nodewebkit-original.svg": 72220,
	"./nodewebkit/nodewebkit-plain-wordmark.svg": 89076,
	"./nodewebkit/nodewebkit-plain.svg": 63463,
	"./nodewebkit/nodewebkit.eps": 31981,
	"./nomad/nomad-original-wordmark.svg": 22733,
	"./nomad/nomad-original.svg": 43480,
	"./nomad/nomad-plain-wordmark.svg": 386,
	"./norg/norg-original.svg": 32775,
	"./norg/norg-plain.svg": 10904,
	"./notion/notion-line.svg": 18906,
	"./notion/notion-original.svg": 73169,
	"./notion/notion-plain.svg": 52035,
	"./npm/npm-original-wordmark.svg": 494,
	"./npm/npm.eps": 14187,
	"./nuget/nuget-original-wordmark.svg": 25129,
	"./nuget/nuget-original.svg": 73593,
	"./numpy/numpy-line-wordmark.svg": 99206,
	"./numpy/numpy-line.svg": 28559,
	"./numpy/numpy-original-wordmark.svg": 69806,
	"./numpy/numpy-original.svg": 32421,
	"./numpy/numpy-plain-wordmark.svg": 73797,
	"./numpy/numpy-plain.svg": 54280,
	"./nuxtjs/nuxtjs-original-wordmark.svg": 25029,
	"./nuxtjs/nuxtjs-original.svg": 76818,
	"./nuxtjs/nuxtjs-plain-wordmark.svg": 83591,
	"./nuxtjs/nuxtjs-plain.svg": 8534,
	"./oauth/oauth-original.svg": 88100,
	"./oauth/oauth-plain.svg": 21011,
	"./objectivec/objectivec-plain.svg": 82071,
	"./objectivec/objectivec.eps": 85670,
	"./ocaml/ocaml-original-wordmark.svg": 12433,
	"./ocaml/ocaml-original.svg": 70633,
	"./ocaml/ocaml-plain-wordmark.svg": 98709,
	"./ocaml/ocaml-plain.svg": 89507,
	"./ohmyzsh/ohmyzsh-original.svg": 85031,
	"./ohmyzsh/ohmyzsh-plain.svg": 66839,
	"./ohmyzsh/ohmyzsh.eps": 26699,
	"./okta/okta-original-wordmark.svg": 93135,
	"./okta/okta-original.svg": 3313,
	"./okta/okta-plain-wordmark.svg": 17939,
	"./okta/okta-plain.svg": 39786,
	"./openal/openal-original.svg": 71671,
	"./openal/openal-plain.svg": 95791,
	"./openapi/openapi-line-wordmark.svg": 27565,
	"./openapi/openapi-line.svg": 95461,
	"./openapi/openapi-original-wordmark.svg": 19445,
	"./openapi/openapi-original.svg": 55305,
	"./openapi/openapi-plain-wordmark.svg": 39104,
	"./openapi/openapi-plain.svg": 41116,
	"./opencl/opencl-line.svg": 7522,
	"./opencl/opencl-original.svg": 98553,
	"./opencl/opencl-plain.svg": 63818,
	"./opencv/opencv-original-wordmark.svg": 47985,
	"./opencv/opencv-original.svg": 46476,
	"./opencv/opencv-plain-wordmark.svg": 14061,
	"./opencv/opencv-plain.svg": 72021,
	"./opengl/opengl-original.svg": 50517,
	"./opengl/opengl-plain.svg": 42693,
	"./openstack/openstack-original-wordmark.svg": 31688,
	"./openstack/openstack-original.svg": 85800,
	"./openstack/openstack-plain-wordmark.svg": 45017,
	"./opensuse/opensuse-original-wordmark.svg": 93188,
	"./opensuse/opensuse-original.svg": 12212,
	"./opentelemetry/opentelemetry-original-wordmark.svg": 56518,
	"./opentelemetry/opentelemetry-original.svg": 63672,
	"./opentelemetry/opentelemetry-plain-wordmark.svg": 32600,
	"./opentelemetry/opentelemetry-plain.svg": 32388,
	"./opera/opera-original-wordmark.svg": 50814,
	"./opera/opera-original.svg": 52038,
	"./opera/opera-plain-wordmark.svg": 80435,
	"./opera/opera-plain.svg": 11942,
	"./oracle/oracle-original.svg": 52204,
	"./oracle/oracle.eps": 33067,
	"./ory/ory-original-wordmark.svg": 1137,
	"./ory/ory-original.svg": 84245,
	"./p5js/p5js-original.svg": 2001,
	"./packer/packer-line-wordmark.svg": 60567,
	"./packer/packer-line.svg": 42361,
	"./packer/packer-original-wordmark.svg": 33994,
	"./packer/packer-original.svg": 55696,
	"./packer/packer-plain-wordmark.svg": 85610,
	"./packer/packer-plain.svg": 52647,
	"./pandas/pandas-line-wordmark.svg": 55855,
	"./pandas/pandas-line.svg": 70266,
	"./pandas/pandas-original-wordmark.svg": 57896,
	"./pandas/pandas-original.svg": 33962,
	"./pandas/pandas-plain-wordmark.svg": 49628,
	"./pandas/pandas-plain.svg": 87475,
	"./perl/perl-original.svg": 85701,
	"./perl/perl-plain.svg": 68164,
	"./pfsense/pfsense-original-wordmark.svg": 89148,
	"./pfsense/pfsense-original.svg": 77406,
	"./phalcon/phalcon-original.svg": 30488,
	"./phalcon/phalcon-plain.svg": 62603,
	"./phalcon/phalcon.eps": 47762,
	"./phoenix/phoenix-original-wordmark.svg": 18807,
	"./phoenix/phoenix-original.svg": 87361,
	"./phoenix/phoenix-plain-wordmark.svg": 40660,
	"./photonengine/photonengine-original.svg": 75910,
	"./photonengine/photonengine-plain.svg": 71384,
	"./photoshop/photoshop-line.svg": 63070,
	"./photoshop/photoshop-original.svg": 96898,
	"./photoshop/photoshop-plain.svg": 77308,
	"./php/php-original.svg": 82550,
	"./php/php-plain.svg": 67535,
	"./phpstorm/phpstorm-original.svg": 31240,
	"./phpstorm/phpstorm-plain-wordmark.svg": 81364,
	"./phpstorm/phpstorm-plain.svg": 58437,
	"./playwright/playwright-original.svg": 5029,
	"./playwright/playwright-plain.svg": 54623,
	"./plotly/plotly-original-wordmark.svg": 40614,
	"./plotly/plotly-original.svg": 3572,
	"./plotly/plotly-plain-wordmark.svg": 61790,
	"./plotly/plotly-plain.svg": 81459,
	"./pnpm/pnpm-original-wordmark.svg": 40746,
	"./pnpm/pnpm-original.svg": 83337,
	"./pnpm/pnpm-plain-wordmark.svg": 15821,
	"./pnpm/pnpm-plain.svg": 71733,
	"./podman/podman-original-wordmark.svg": 76106,
	"./podman/podman-original.svg": 50520,
	"./podman/podman-plain-wordmark.svg": 15720,
	"./podman/podman-plain.svg": 26513,
	"./poetry/poetry-original.svg": 36584,
	"./poetry/poetry-plain.svg": 74915,
	"./polygon/polygon-original-wordmark.svg": 91721,
	"./polygon/polygon-original.svg": 77523,
	"./polygon/polygon-plain-wordmark.svg": 73292,
	"./polygon/polygon-plain.svg": 25303,
	"./portainer/portainer-original-wordmark.svg": 15185,
	"./portainer/portainer-original.svg": 93955,
	"./postcss/postcss-original-wordmark.svg": 36881,
	"./postcss/postcss-original.svg": 71163,
	"./postcss/postcss-plain-wordmark.svg": 4213,
	"./postgresql/postgresql-original-wordmark.svg": 63099,
	"./postgresql/postgresql-original.svg": 3213,
	"./postgresql/postgresql-plain-wordmark.svg": 13661,
	"./postgresql/postgresql-plain.svg": 15174,
	"./postgresql/postgresql.eps": 14785,
	"./postman/postman-original-wordmark.svg": 67603,
	"./postman/postman-original.svg": 2655,
	"./postman/postman-plain-wordmark.svg": 89083,
	"./postman/postman-plain.svg": 53613,
	"./powershell/powershell-original.svg": 25074,
	"./powershell/powershell-plain.svg": 25443,
	"./powershell/powershell.eps": 11010,
	"./premierepro/premierepro-original.svg": 15710,
	"./premierepro/premierepro-plain.svg": 70659,
	"./premierepro/premierepro.eps": 67586,
	"./prisma/prisma-original-wordmark.svg": 7726,
	"./prisma/prisma-original.svg": 82982,
	"./processing/processing-original-wordmark.svg": 35385,
	"./processing/processing-original.svg": 87823,
	"./processing/processing-plain-wordmark.svg": 61935,
	"./processing/processing-plain.svg": 34551,
	"./prolog/prolog-original-wordmark.svg": 12167,
	"./prolog/prolog-original.svg": 92737,
	"./prolog/prolog-plain-wordmark.svg": 40441,
	"./prolog/prolog-plain.svg": 60931,
	"./prometheus/prometheus-line-wordmark.svg": 97345,
	"./prometheus/prometheus-line.svg": 94972,
	"./prometheus/prometheus-original-wordmark.svg": 73272,
	"./prometheus/prometheus-original.svg": 62065,
	"./prometheus/prometheus-plain-wordmark.svg": 10057,
	"./protractor/protractor-line-wordmark.svg": 69143,
	"./protractor/protractor-line.svg": 33869,
	"./protractor/protractor-original-wordmark.svg": 31606,
	"./protractor/protractor-original.svg": 32716,
	"./protractor/protractor-plain-wordmark.svg": 1858,
	"./protractor/protractor-plain.svg": 18911,
	"./pulsar/pulsar-original-wordmark.svg": 70228,
	"./pulsar/pulsar-original.svg": 66917,
	"./pulumi/pulumi-original-wordmark.svg": 326,
	"./pulumi/pulumi-original.svg": 52918,
	"./pulumi/pulumi-plain-wordmark.svg": 49088,
	"./pulumi/pulumi-plain.svg": 2978,
	"./puppeteer/puppeteer-original.svg": 98413,
	"./puppeteer/puppeteer-plain.svg": 81882,
	"./purescript/purescript-original-wordmark.svg": 83705,
	"./purescript/purescript-original.svg": 87468,
	"./putty/putty-original.svg": 73876,
	"./putty/putty-plain.svg": 15789,
	"./pycharm/pycharm-original-wordmark.svg": 20548,
	"./pycharm/pycharm-original.svg": 92850,
	"./pycharm/pycharm-plain-wordmark.svg": 13586,
	"./pycharm/pycharm-plain.svg": 90527,
	"./pypi/pypi-original-wordmark.svg": 54430,
	"./pypi/pypi-original.svg": 7205,
	"./pypi/pypi-plain-wordmark.svg": 19336,
	"./pypi/pypi-plain.svg": 1188,
	"./pyscript/pyscript-original-wordmark.svg": 31748,
	"./pyscript/pyscript-plain-wordmark.svg": 50657,
	"./pytest/pytest-original-wordmark.svg": 99918,
	"./pytest/pytest-original.svg": 16008,
	"./pytest/pytest-plain-wordmark.svg": 53963,
	"./pytest/pytest-plain.svg": 5537,
	"./python/python-original-wordmark.svg": 47526,
	"./python/python-original.svg": 65326,
	"./python/python-plain-wordmark.svg": 59491,
	"./python/python-plain.svg": 27240,
	"./python/python.eps": 98597,
	"./pytorch/pytorch-original-wordmark.svg": 80699,
	"./pytorch/pytorch-original.svg": 21508,
	"./pytorch/pytorch-plain-wordmark.svg": 59194,
	"./pytorch/pytorch.eps": 15254,
	"./qodana/qodana-original.svg": 74379,
	"./qodana/qodana-plain-wordmark.svg": 27989,
	"./qodana/qodana-plain.svg": 90622,
	"./qt/qt-original.svg": 99114,
	"./quarkus/quarkus-original-wordmark.svg": 30440,
	"./quarkus/quarkus-original.svg": 79241,
	"./quarkus/quarkus-plain-wordmark.svg": 1690,
	"./quarkus/quarkus-plain.svg": 6004,
	"./quasar/quasar-original-wordmark.svg": 64542,
	"./quasar/quasar-original.svg": 54020,
	"./quasar/quasar-plain-wordmark.svg": 96726,
	"./quasar/quasar-plain.svg": 30841,
	"./qwik/qwik-original-wordmark.svg": 69031,
	"./qwik/qwik-original.svg": 96982,
	"./qwik/qwik-plain-wordmark.svg": 52153,
	"./qwik/qwik-plain.svg": 10668,
	"./r/r-line.svg": 25477,
	"./r/r-original.svg": 68397,
	"./r/r-plain.svg": 71544,
	"./rabbitmq/rabbitmq-original-wordmark.svg": 64657,
	"./rabbitmq/rabbitmq-original.svg": 12736,
	"./rabbitmq/rabbitmq-plain-wordmark.svg": 14659,
	"./rails/rails-original-wordmark.svg": 10507,
	"./rails/rails-plain-wordmark.svg": 44398,
	"./rails/rails-plain.svg": 48111,
	"./rails/rails.eps": 54776,
	"./railway/railway-line-wordmark.svg": 47025,
	"./railway/railway-line.svg": 59004,
	"./railway/railway-original-wordmark.svg": 60571,
	"./railway/railway-original.svg": 41154,
	"./rancher/rancher-line-wordmark.svg": 54625,
	"./rancher/rancher-line.svg": 70330,
	"./rancher/rancher-original-wordmark.svg": 6327,
	"./rancher/rancher-original.svg": 77224,
	"./rancher/rancher-plain-wordmark.svg": 839,
	"./raspberrypi/raspberrypi-line-wordmark.svg": 60583,
	"./raspberrypi/raspberrypi-line.svg": 64646,
	"./raspberrypi/raspberrypi-original-wordmark.svg": 13978,
	"./raspberrypi/raspberrypi-original.svg": 81,
	"./raspberrypi/raspberrypi-plain-wordmark.svg": 2356,
	"./raspberrypi/raspberrypi-plain.svg": 27296,
	"./reach/reach-original.svg": 53972,
	"./reach/reach-plain.svg": 62140,
	"./react/react-original-wordmark.svg": 75242,
	"./react/react-original.svg": 94446,
	"./react/react.eps": 45605,
	"./reactbootstrap/reactbootstrap-original.svg": 72315,
	"./reactnavigation/reactnavigation-original.svg": 69940,
	"./reactrouter/reactrouter-original-wordmark.svg": 57388,
	"./reactrouter/reactrouter-original.svg": 42857,
	"./reactrouter/reactrouter-plain-wordmark.svg": 93035,
	"./reactrouter/reactrouter-plain.svg": 30439,
	"./readthedocs/readthedocs-line.svg": 42200,
	"./readthedocs/readthedocs-original-wordmark.svg": 29181,
	"./readthedocs/readthedocs-original.svg": 88968,
	"./realm/realm-original-wordmark.svg": 17949,
	"./realm/realm-original.svg": 84614,
	"./realm/realm-plain-wordmark.svg": 19003,
	"./realm/realm-plain.svg": 66488,
	"./rect/rect-original.svg": 30639,
	"./rect/rect-plain.svg": 70520,
	"./redhat/redhat-original-wordmark.svg": 83563,
	"./redhat/redhat-original.svg": 77474,
	"./redhat/redhat-plain-wordmark.svg": 24388,
	"./redhat/redhat-plain.svg": 30994,
	"./redhat/redhat.eps": 26263,
	"./redis/redis-original-wordmark.svg": 73378,
	"./redis/redis-original.svg": 72575,
	"./redis/redis-plain-wordmark.svg": 92702,
	"./redis/redis-plain.svg": 64313,
	"./redis/redis.eps": 18132,
	"./redux/redux-original.svg": 3952,
	"./redux/redux.eps": 94222,
	"./renpy/renpy-original.svg": 67757,
	"./renpy/renpy-plain.svg": 4567,
	"./replit/replit-original-wordmark.svg": 57243,
	"./replit/replit-original.svg": 94403,
	"./replit/replit-plain-wordmark.svg": 31907,
	"./rider/rider-original-wordmark.svg": 81803,
	"./rider/rider-original.svg": 80437,
	"./rider/rider-plain-wordmark.svg": 19295,
	"./rider/rider-plain.svg": 86077,
	"./rocksdb/rocksdb-line.svg": 57537,
	"./rocksdb/rocksdb-original.svg": 49548,
	"./rocksdb/rocksdb-plain.svg": 60134,
	"./rockylinux/rockylinux-original-wordmark.svg": 98834,
	"./rockylinux/rockylinux-original.svg": 40350,
	"./rockylinux/rockylinux-plain-wordmark.svg": 85663,
	"./rollup/rollup-line-wordmark.svg": 45610,
	"./rollup/rollup-line.svg": 23138,
	"./rollup/rollup-original-wordmark.svg": 65856,
	"./rollup/rollup-original.svg": 19956,
	"./rollup/rollup-plain-wordmark.svg": 81509,
	"./rollup/rollup-plain.svg": 93451,
	"./rollup/rollup.eps": 55860,
	"./ros/ros-original-wordmark.svg": 15882,
	"./ros/ros-original.svg": 56899,
	"./rspec/rspec-line-wordmark.svg": 98984,
	"./rspec/rspec-line.svg": 3961,
	"./rspec/rspec-original-wordmark.svg": 51082,
	"./rspec/rspec-original.svg": 54392,
	"./rspec/rspec-plain-wordmark.svg": 84141,
	"./rspec/rspec-plain.svg": 66884,
	"./rstudio/rstudio-original.svg": 44880,
	"./rstudio/rstudio-plain.svg": 82528,
	"./ruby/ruby-original-wordmark.svg": 55420,
	"./ruby/ruby-original.svg": 848,
	"./ruby/ruby-plain-wordmark.svg": 64698,
	"./ruby/ruby-plain.svg": 50759,
	"./ruby/ruby.eps": 20198,
	"./rubymine/rubymine-original-wordmark.svg": 36877,
	"./rubymine/rubymine-original.svg": 17169,
	"./rubymine/rubymine-plain-wordmark.svg": 91507,
	"./rubymine/rubymine-plain.svg": 38718,
	"./rust/rust-line.svg": 37535,
	"./rust/rust-original.svg": 26452,
	"./rxjs/rxjs-original.svg": 13823,
	"./rxjs/rxjs-plain.svg": 88979,
	"./safari/safari-line-wordmark.svg": 60372,
	"./safari/safari-line.svg": 73347,
	"./safari/safari-original-wordmark.svg": 94967,
	"./safari/safari-original.svg": 6362,
	"./safari/safari-plain-wordmark.svg": 75779,
	"./safari/safari-plain.svg": 20406,
	"./safari/safari.eps": 62694,
	"./salesforce/salesforce-original.svg": 95938,
	"./salesforce/salesforce-plain.svg": 39563,
	"./salesforce/salesforce.eps": 82675,
	"./sanity/sanity-original.svg": 65399,
	"./sanity/sanity-plain.svg": 71524,
	"./sass/sass-original.svg": 13972,
	"./sass/sass.eps": 8414,
	"./scala/scala-original-wordmark.svg": 45394,
	"./scala/scala-original.svg": 82781,
	"./scala/scala-plain-wordmark.svg": 50827,
	"./scala/scala-plain.svg": 13425,
	"./scalingo/scalingo-line-wordmark.svg": 78115,
	"./scalingo/scalingo-line.svg": 72262,
	"./scalingo/scalingo-original-wordmark.svg": 58381,
	"./scalingo/scalingo-original.svg": 93654,
	"./scalingo/scalingo-plain-wordmark.svg": 47408,
	"./scalingo/scalingo-plain.svg": 33992,
	"./scikitlearn/scikitlearn-line.svg": 62827,
	"./scikitlearn/scikitlearn-original.svg": 80785,
	"./scikitlearn/scikitlearn-plain.svg": 34458,
	"./sdl/sdl-original.svg": 64855,
	"./sdl/sdl-plain.svg": 21283,
	"./selenium/selenium-original.svg": 25870,
	"./selenium/selenium.eps": 47730,
	"./sema/sema-original-wordmark.svg": 9242,
	"./sema/sema-original.svg": 92900,
	"./sentry/sentry-original-wordmark.svg": 65409,
	"./sentry/sentry-original.svg": 73396,
	"./sequelize/sequelize-original-wordmark.svg": 10674,
	"./sequelize/sequelize-original.svg": 81006,
	"./sequelize/sequelize-plain-wordmark.svg": 82188,
	"./sequelize/sequelize-plain.svg": 72250,
	"./sequelize/sequelize.eps": 98540,
	"./shopware/shopware-original-wordmark.svg": 94250,
	"./shopware/shopware-original.svg": 80112,
	"./shopware/shopware.eps": 70783,
	"./shotgrid/shotgrid-original-wordmark.svg": 10886,
	"./shotgrid/shotgrid-original.svg": 49135,
	"./shotgrid/shotgrid-plain.svg": 85089,
	"./shotgrid/shotgrid.eps": 44113,
	"./sketch/sketch-line-wordmark.svg": 37159,
	"./sketch/sketch-line.svg": 8310,
	"./sketch/sketch-original-wordmark.svg": 98918,
	"./sketch/sketch-original.svg": 16600,
	"./sketch/sketch-plain-wordmark.svg": 94806,
	"./sketch/sketch-plain.svg": 32679,
	"./slack/slack-original-wordmark.svg": 22398,
	"./slack/slack-original.svg": 22374,
	"./slack/slack-plain-wordmark.svg": 99815,
	"./slack/slack-plain.svg": 81528,
	"./socketio/socketio-original-wordmark.svg": 45053,
	"./socketio/socketio-original.svg": 43614,
	"./solidity/solidity-original.svg": 46917,
	"./solidity/solidity-plain.svg": 69285,
	"./solidjs/solidjs-original-wordmark.svg": 7001,
	"./solidjs/solidjs-original.svg": 96292,
	"./solidjs/solidjs-plain-wordmark.svg": 17277,
	"./solidjs/solidjs-plain.svg": 99927,
	"./sonarqube/sonarqube-line-wordmark.svg": 30230,
	"./sonarqube/sonarqube-line.svg": 93359,
	"./sonarqube/sonarqube-original-wordmark.svg": 5690,
	"./sonarqube/sonarqube-original.svg": 2871,
	"./sonarqube/sonarqube-plain-wordmark.svg": 8376,
	"./sourcetree/sourcetree-original-wordmark.svg": 79430,
	"./sourcetree/sourcetree-original.svg": 25934,
	"./sourcetree/sourcetree.eps": 96826,
	"./spack/spack-original.svg": 65607,
	"./spack/spack-plain.svg": 82821,
	"./spack/spack.eps": 33649,
	"./splunk/splunk-original-wordmark.svg": 55118,
	"./spring/spring-original-wordmark.svg": 25215,
	"./spring/spring-original.svg": 761,
	"./spss/spss-original.svg": 2519,
	"./spss/spss-plain.svg": 54269,
	"./spss/spss.eps": 1331,
	"./spyder/spyder-original-wordmark.svg": 48653,
	"./spyder/spyder-original.svg": 54106,
	"./spyder/spyder-plain-wordmark.svg": 87010,
	"./spyder/spyder-plain.svg": 15669,
	"./sqlalchemy/sqlalchemy-original-wordmark.svg": 12904,
	"./sqlalchemy/sqlalchemy-original.svg": 53998,
	"./sqlalchemy/sqlalchemy-plain-wordmark.svg": 97233,
	"./sqlalchemy/sqlalchemy-plain.svg": 2370,
	"./sqldeveloper/sqldeveloper-original.svg": 92986,
	"./sqldeveloper/sqldeveloper-plain.svg": 43492,
	"./sqlite/sqlite-original-wordmark.svg": 78575,
	"./sqlite/sqlite-original.svg": 7332,
	"./sqlite/sqlite-plain-wordmark.svg": 25042,
	"./sqlite/sqlite-plain.svg": 27,
	"./ssh/ssh-original-wordmark.svg": 20824,
	"./ssh/ssh-original.svg": 80204,
	"./ssh/ssh.eps": 50099,
	"./stackoverflow/stackoverflow-line-wordmark.svg": 90729,
	"./stackoverflow/stackoverflow-line.svg": 5406,
	"./stackoverflow/stackoverflow-original-wordmark.svg": 83523,
	"./stackoverflow/stackoverflow-original.svg": 55748,
	"./stackoverflow/stackoverflow-plain-wordmark.svg": 17118,
	"./stackoverflow/stackoverflow-plain.svg": 75449,
	"./stata/stata-original-wordmark.svg": 1965,
	"./storybook/storybook-original-wordmark.svg": 89497,
	"./storybook/storybook-original.svg": 46880,
	"./storybook/storybook-plain-wordmark.svg": 58109,
	"./storybook/storybook-plain.svg": 14361,
	"./streamlit/streamlit-original-wordmark.svg": 29401,
	"./streamlit/streamlit-original.svg": 34454,
	"./streamlit/streamlit-plain-wordmark.svg": 91578,
	"./streamlit/streamlit-plain.svg": 76257,
	"./stylus/stylus-original.svg": 36215,
	"./stylus/stylus.eps": 9592,
	"./subversion/subversion-original-wordmark.svg": 30923,
	"./subversion/subversion-original.svg": 53403,
	"./subversion/subversion-plain-wordmark.svg": 53046,
	"./supabase/supabase-original-wordmark.svg": 49893,
	"./supabase/supabase-original.svg": 12831,
	"./supabase/supabase-plain-wordmark.svg": 59454,
	"./supabase/supabase-plain.svg": 35403,
	"./svelte/svelte-original-wordmark.svg": 54224,
	"./svelte/svelte-original.svg": 51740,
	"./svelte/svelte-plain-wordmark.svg": 90978,
	"./svelte/svelte-plain.svg": 28025,
	"./swagger/swagger-original-wordmark.svg": 6236,
	"./swagger/swagger-original.svg": 69163,
	"./swagger/swagger-plain-wordmark.svg": 36542,
	"./swagger/swagger-plain.svg": 80003,
	"./swift/swift-original-wordmark.svg": 42382,
	"./swift/swift-original.svg": 68408,
	"./swift/swift-plain-wordmark.svg": 15792,
	"./swift/swift-plain.svg": 93270,
	"./swift/swift.eps": 87608,
	"./swiper/swiper-original.svg": 43524,
	"./symfony/symfony-original-wordmark.svg": 87141,
	"./symfony/symfony-original.svg": 88485,
	"./symfony/symfony.eps": 25866,
	"./tailwindcss/tailwindcss-original-wordmark.svg": 56153,
	"./tailwindcss/tailwindcss-original.svg": 90948,
	"./tailwindcss/tailwindcss-plain-wordmark.svg": 98947,
	"./tauri/tauri-original-wordmark.svg": 94596,
	"./tauri/tauri-original.svg": 45037,
	"./tauri/tauri-plain-wordmark.svg": 90061,
	"./tauri/tauri-plain.svg": 58705,
	"./tensorflow/tensorflow-line-wordmark.svg": 94568,
	"./tensorflow/tensorflow-line.svg": 92003,
	"./tensorflow/tensorflow-original-wordmark.svg": 97130,
	"./tensorflow/tensorflow-original.svg": 83472,
	"./terraform/terraform-original-wordmark.svg": 6432,
	"./terraform/terraform-original.svg": 18697,
	"./terraform/terraform-plain-wordmark.svg": 6321,
	"./terraform/terraform-plain.svg": 84241,
	"./tex/tex-original.svg": 56427,
	"./thealgorithms/thealgorithms-original-wordmark.svg": 61307,
	"./thealgorithms/thealgorithms-original.svg": 87085,
	"./thealgorithms/thealgorithms-plain-wordmark.svg": 10962,
	"./thealgorithms/thealgorithms-plain.svg": 60576,
	"./threedsmax/threedsmax-original.svg": 56225,
	"./threedsmax/threedsmax-plain.svg": 78163,
	"./threejs/threejs-original-wordmark.svg": 90576,
	"./threejs/threejs-original.svg": 6228,
	"./titaniumsdk/titaniumsdk-original.svg": 87044,
	"./tomcat/tomcat-line-wordmark.svg": 39751,
	"./tomcat/tomcat-line.svg": 63089,
	"./tomcat/tomcat-original-wordmark.svg": 27701,
	"./tomcat/tomcat-original.svg": 34916,
	"./tomcat/tomcat.eps": 19049,
	"./tortoisegit/tortoisegit-line.svg": 95482,
	"./tortoisegit/tortoisegit-original.svg": 37078,
	"./tortoisegit/tortoisegit-plain.svg": 68330,
	"./towergit/towergit-original-wordmark.svg": 52586,
	"./towergit/towergit-original.svg": 16441,
	"./towergit/towergit-plain-wordmark.svg": 5479,
	"./towergit/towergit-plain.svg": 31529,
	"./traefikmesh/traefikmesh-line-wordmark.svg": 78946,
	"./traefikmesh/traefikmesh-line.svg": 30154,
	"./traefikmesh/traefikmesh-original-wordmark.svg": 83714,
	"./traefikmesh/traefikmesh-original.svg": 58224,
	"./traefikmesh/traefikmesh-plain-wordmark.svg": 25358,
	"./traefikproxy/traefikproxy-line-wordmark.svg": 49582,
	"./traefikproxy/traefikproxy-line.svg": 32407,
	"./traefikproxy/traefikproxy-original-wordmark.svg": 43149,
	"./traefikproxy/traefikproxy-original.svg": 34558,
	"./traefikproxy/traefikproxy-plain-wordmark.svg": 98976,
	"./travis/travis-line-wordmark.svg": 74817,
	"./travis/travis-line.svg": 45441,
	"./travis/travis-original-wordmark.svg": 47196,
	"./travis/travis-original.svg": 41676,
	"./travis/travis-plain-wordmark.svg": 20309,
	"./travis/travis-plain.svg": 18171,
	"./trello/trello-line-wordmark.svg": 95570,
	"./trello/trello-line.svg": 36691,
	"./trello/trello-original-wordmark.svg": 48195,
	"./trello/trello-original.svg": 24170,
	"./trello/trello-plain-wordmark.svg": 57694,
	"./trello/trello-plain.svg": 98806,
	"./trpc/trpc-original-wordmark.svg": 82077,
	"./trpc/trpc-original.svg": 83058,
	"./trpc/trpc-plain-wordmark.svg": 84001,
	"./trpc/trpc-plain.svg": 61175,
	"./twitter/twitter-original.svg": 44660,
	"./typescript/typescript-original.svg": 5238,
	"./typescript/typescript-plain.svg": 72380,
	"./typescript/typescript.eps": 24369,
	"./typo3/typo3-line-wordmark.svg": 93802,
	"./typo3/typo3-line.svg": 82500,
	"./typo3/typo3-original-wordmark.svg": 70557,
	"./typo3/typo3-original.svg": 29604,
	"./typo3/typo3-plain-wordmark.svg": 37020,
	"./typo3/typo3.eps": 89612,
	"./ubuntu/ubuntu-original-wordmark.svg": 60389,
	"./ubuntu/ubuntu-original.svg": 13222,
	"./ubuntu/ubuntu-plain-wordmark.svg": 23593,
	"./ubuntu/ubuntu-plain.svg": 32117,
	"./ubuntu/ubuntu.eps": 3720,
	"./unifiedmodelinglanguage/unifiedmodelinglanguage-original-wordmark.svg": 14475,
	"./unifiedmodelinglanguage/unifiedmodelinglanguage-original.svg": 96684,
	"./unifiedmodelinglanguage/unifiedmodelinglanguage-plain-wordmark.svg": 4901,
	"./unifiedmodelinglanguage/unifiedmodelinglanguage-plain.svg": 98828,
	"./unity/unity-line-wordmark.svg": 4273,
	"./unity/unity-line.svg": 10017,
	"./unity/unity-original-wordmark.svg": 92129,
	"./unity/unity-original.svg": 82296,
	"./unity/unity-plain-wordmark.svg": 60062,
	"./unity/unity-plain.svg": 5145,
	"./unix/unix-original.svg": 50686,
	"./unix/unix.eps": 64349,
	"./unrealengine/unrealengine-original-wordmark.svg": 22111,
	"./unrealengine/unrealengine-original.svg": 35570,
	"./uwsgi/uwsgi-original.svg": 85276,
	"./uwsgi/uwsgi-plain.svg": 49412,
	"./uwsgi/uwsgi.eps": 69557,
	"./v8/v8-original.svg": 10845,
	"./v8/v8-plain.svg": 52400,
	"./vagrant/vagrant-original-wordmark.svg": 29128,
	"./vagrant/vagrant-original.svg": 62716,
	"./vagrant/vagrant-plain-wordmark.svg": 52042,
	"./vagrant/vagrant-plain.svg": 65609,
	"./vagrant/vagrant.eps": 42796,
	"./vala/vala-original-wordmark.svg": 79380,
	"./vala/vala-original.svg": 3184,
	"./vala/vala-plain-wordmark.svg": 24862,
	"./vala/vala-plain.svg": 75562,
	"./vault/vault-original-wordmark.svg": 5563,
	"./vault/vault-original.svg": 41601,
	"./vault/vault-plain-wordmark.svg": 86474,
	"./vercel/vercel-line-wordmark.svg": 1731,
	"./vercel/vercel-line.svg": 72504,
	"./vercel/vercel-original-wordmark.svg": 71998,
	"./vercel/vercel-original.svg": 14540,
	"./vertx/vertx-line-wordmark.svg": 61757,
	"./vertx/vertx-line.svg": 45447,
	"./vertx/vertx-original-wordmark.svg": 77737,
	"./vertx/vertx-original.svg": 85877,
	"./vertx/vertx-plain-wordmark.svg": 67394,
	"./vertx/vertx-plain.svg": 88699,
	"./vim/vim-original.svg": 60729,
	"./vim/vim-plain.svg": 68968,
	"./vim/vim.eps": 42346,
	"./visualbasic/visualbasic-line.svg": 38540,
	"./visualbasic/visualbasic-original.svg": 19422,
	"./visualbasic/visualbasic-plain.svg": 12994,
	"./visualstudio/visualstudio-line-wordmark.svg": 68888,
	"./visualstudio/visualstudio-line.svg": 45722,
	"./visualstudio/visualstudio-original-wordmark.svg": 20280,
	"./visualstudio/visualstudio-original.svg": 27791,
	"./visualstudio/visualstudio-plain-wordmark.svg": 90431,
	"./visualstudio/visualstudio-plain.svg": 30203,
	"./vite/vite-original-wordmark.svg": 27111,
	"./vite/vite-original.svg": 87251,
	"./vitejs/vitejs-original.svg": 24389,
	"./vitejs/vitejs-plain.svg": 42891,
	"./vitess/vitess-original-wordmark.svg": 40793,
	"./vitess/vitess-original.svg": 33251,
	"./vitess/vitess-plain-wordmark.svg": 70486,
	"./vitess/vitess-plain.svg": 32725,
	"./vitest/vitest-original.svg": 28829,
	"./vitest/vitest-plain.svg": 48746,
	"./vscode/vscode-original-wordmark.svg": 8159,
	"./vscode/vscode-original.svg": 62218,
	"./vscode/vscode-plain-wordmark.svg": 39403,
	"./vscode/vscode-plain.svg": 3151,
	"./vsphere/vsphere-line-wordmark.svg": 66411,
	"./vsphere/vsphere-line.svg": 42948,
	"./vsphere/vsphere-original-wordmark.svg": 6955,
	"./vsphere/vsphere-original.svg": 93577,
	"./vsphere/vsphere-plain-wordmark.svg": 44816,
	"./vsphere/vsphere-plain.svg": 63916,
	"./vuejs/vuejs-line-wordmark.svg": 59612,
	"./vuejs/vuejs-line.svg": 90493,
	"./vuejs/vuejs-original-wordmark.svg": 16076,
	"./vuejs/vuejs-original.svg": 4063,
	"./vuejs/vuejs-plain-wordmark.svg": 49334,
	"./vuejs/vuejs-plain.svg": 48546,
	"./vuejs/vuejs.eps": 19611,
	"./vuestorefront/vuestorefront-original.svg": 79205,
	"./vuestorefront/vuestorefront-plain.svg": 81654,
	"./vuestorefront/vuestorefront.eps": 51067,
	"./vuetify/vuetify-line.svg": 77084,
	"./vuetify/vuetify-original.svg": 70965,
	"./vuetify/vuetify-plain.svg": 42940,
	"./vyper/vyper-original-wordmark.svg": 93216,
	"./vyper/vyper-original.svg": 7943,
	"./vyper/vyper-plain-wordmark.svg": 16518,
	"./vyper/vyper-plain.svg": 51465,
	"./wasm/wasm-original-wordmark.svg": 54646,
	"./wasm/wasm-original.svg": 55157,
	"./wasm/wasm-plain-wordmark.svg": 13379,
	"./webflow/webflow-original.svg": 32029,
	"./weblate/weblate-original-wordmark.svg": 73117,
	"./weblate/weblate-original.svg": 93161,
	"./weblate/weblate-plain-wordmark.svg": 14179,
	"./weblate/weblate-plain.svg": 39727,
	"./webpack/webpack-original-wordmark.svg": 59490,
	"./webpack/webpack-original.svg": 94622,
	"./webpack/webpack-plain-wordmark.svg": 6991,
	"./webpack/webpack-plain.svg": 51200,
	"./webpack/webpack.eps": 14997,
	"./webstorm/webstorm-original-wordmark.svg": 56819,
	"./webstorm/webstorm-original.svg": 74350,
	"./webstorm/webstorm-plain-wordmark.svg": 64522,
	"./webstorm/webstorm-plain.svg": 31654,
	"./windows11/windows11-original-wordmark.svg": 19938,
	"./windows11/windows11-original.svg": 89142,
	"./windows8/windows8-original-wordmark.svg": 5612,
	"./windows8/windows8-original.svg": 86506,
	"./windows8/windows8.eps": 23014,
	"./woocommerce/woocommerce-original-wordmark.svg": 34036,
	"./woocommerce/woocommerce-original.svg": 92045,
	"./woocommerce/woocommerce-plain-wordmark.svg": 75830,
	"./woocommerce/woocommerce-plain.svg": 62160,
	"./woocommerce/woocommerce.eps": 91623,
	"./wordpress/wordpress-original.svg": 12590,
	"./wordpress/wordpress-plain-wordmark.svg": 83482,
	"./wordpress/wordpress-plain.svg": 53626,
	"./wordpress/wordpress.eps": 25200,
	"./xamarin/xamarin-original-wordmark.svg": 33940,
	"./xamarin/xamarin-original.svg": 93652,
	"./xamarin/xamarin.eps": 59181,
	"./xcode/xcode-original.svg": 17663,
	"./xcode/xcode-plain.svg": 2416,
	"./xcode/xcode.eps": 77787,
	"./xd/xd-line.svg": 81972,
	"./xd/xd-original.svg": 91293,
	"./xd/xd-plain.svg": 8802,
	"./xml/xml-line.svg": 59686,
	"./xml/xml-original.svg": 12196,
	"./xml/xml-plain.svg": 11653,
	"./yaml/yaml-original.svg": 29268,
	"./yaml/yaml-plain.svg": 96111,
	"./yarn/yarn-line-wordmark.svg": 25203,
	"./yarn/yarn-line.svg": 6119,
	"./yarn/yarn-original-wordmark.svg": 92051,
	"./yarn/yarn-original.svg": 98173,
	"./yii/yii-original-wordmark.svg": 96743,
	"./yii/yii-original.svg": 5981,
	"./yii/yii-plain-wordmark.svg": 37585,
	"./yii/yii-plain.svg": 66421,
	"./yugabytedb/yugabytedb-original-wordmark.svg": 31699,
	"./yugabytedb/yugabytedb-original.svg": 64231,
	"./yugabytedb/yugabytedb-plain-wordmark.svg": 90935,
	"./yugabytedb/yugabytedb-plain.svg": 6616,
	"./yunohost/yunohost-original.svg": 37328,
	"./yunohost/yunohost-plain.svg": 79142,
	"./yunohost/yunohost.eps": 42287,
	"./zend/zend-line-wordmark.svg": 82245,
	"./zend/zend-line.svg": 18543,
	"./zend/zend-original-wordmark.svg": 15616,
	"./zend/zend-original.svg": 67160,
	"./zig/zig-original-wordmark.svg": 33137,
	"./zig/zig-original.svg": 14826,
	"./zig/zig-plain-wordmark.svg": 48701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;